module.exports = __webpack_public_path__ + "static/media/add-icon.c854abc4.svg";